import { render, staticRenderFns } from "./addGoodsPurchase.vue?vue&type=template&id=6419e57c&scoped=true"
import script from "./addGoodsPurchase.vue?vue&type=script&lang=js"
export * from "./addGoodsPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419e57c",
  null
  
)

export default component.exports